import {formatService} from '@/service/formatService'

export const historyService = {
  getCode () {
    var str = []
    for (var i = 65; i < 91; i++) {
      str.push(String.fromCharCode(i))
    }
    return str
  },
  handleMenuData (obj, params, dictionary) {
    obj.select = true
    let Index = obj.Data.findIndex(column => {
      return dictionary[params.time] === column.Name
    })
    obj.Data.forEach((item, index) => {
      item.select = index === Index
    })
    return obj
  },
  handleEventData (res, flag) {
    let showData = []
    if (flag) {
      res.data.forEach(item => {
        item.title = item.Year || item.TypeName
        item.gambit = item.Columns
      })
      showData = res.data
    } else {
      showData = res.data.length > 0 ? formatService.getListByTime(res.data) : res.data
    }
    return showData
  },
  handleTwoMenu (ary, params, dictionary) {
    ary.forEach((item, index) => {
      item.select = (index + '') === params.type
      let Index = item.Data.findIndex(column => {
        if (params.type === '0') {
          return dictionary.nameLevel[params.time] === column.Name
        } else {
          let key = params.year ? params.year : params.time
          return dictionary.typeLevel[key] === column.Name
        }
      })
      item.Data.forEach((data, index) => {
        data.select = index === Index
      })
    })
    return ary
  },
  handleUrl (url, codes) {
    let allLetters = this.getCode()
    let start = allLetters.findIndex(item => item === codes[0])
    let end = allLetters.findIndex(item => item === codes[codes.length - 1])
    allLetters.forEach((item, index) => {
      if (index === start) {
        url += '?letters=' + item
      } else if (index > start && index <= end) {
        url += '&letters=' + item
      }
    })
    return url
  },
  routeShowName (name, params, dictionary) {
    let showName = ''
    switch (name) {
      case 'type':
        showName = dictionary.oneLevel[params.type]
        break
      case 'time':
        showName = dictionary.typeLevel[params.time]
        break
      case 'year':
        showName = dictionary.typeLevel[params.year]
        break
      case 'column':
        showName = params.column
        break
      case 'propType':
        showName = params.propType
        break
      default:
        break
    }
    return showName
  },
  showName (name, params, dictionary) {
    let showName = ''
    switch (name) {
      case 'type':
        showName = dictionary.oneLevel[params.type]
        break
      case 'time':
        let curr = params.type === '0' ? dictionary.nameLevel : dictionary.typeLevel
        showName = curr[params.time]
        break
      case 'year':
        showName = params.type === '0' && params.year.replace(/\s/g, '') ? (params.year + '年') : dictionary.typeLevel[params.year]
        break
      case 'column':
        showName = params.column
        break
      case 'propType':
        showName = params.propType
        break
      default:
        break
    }
    return showName
  },
  routeChange (ary, params, dictionary, flag) {
    for (let arr in params) {
      if (params[arr]) {
        let showName = flag ? this.showName(arr, params, dictionary) : this.routeShowName(arr, params, dictionary)
        let currObj = {
          url: params[arr],
          name: showName || '',
          type: arr
        }
        ary.push(currObj)
      }
    }
    return ary
  }
}



// WEBPACK FOOTER //
// ./src/service/historyService.js